import cls from "classnames";
import { useMemo } from "react";
import { getDurationLabel } from "@qoohoo/common/utils/date";

const MembershipDurationLabel = ({className, isVisible, link, linkLabel, userChannelDetail, isHeaderMode, colFormat=false, indicator, bottomContent}) => {
  const durationLabel = useMemo(() => {
    if (Object.keys(userChannelDetail).length > 0) {
        const isOneTime = ["one_time","multi_day_session","free_subscription"].indexOf(userChannelDetail.type?.toLowerCase()) > -1;
        
        const startDate = isOneTime ? userChannelDetail.member_joined_at: userChannelDetail.membership_period_start;
        const endDate = isOneTime ? userChannelDetail.end_date : userChannelDetail.membership_period_end;
        
        return getDurationLabel(
          new Date(startDate),
          endDate && new Date(endDate),
        );
    } else return "";
  }, [userChannelDetail]);

  const linkIsFunction = typeof link === "function";

  const handleClick = () => {
    if(linkIsFunction) {
        link();
    } else {
        window.open(link,"_blank");
    }
  }

  
  let content = (
    <div className={cls("w-full flex", link ? "justify-between" : "justify-center" , className)}>
        <div className={cls("flex", colFormat && "flex-col" )}>
          <span className="font-normal text-[13px] leading-5 text-white mr-1 dark:text-[#16191B]">
            {indicator ? `${indicator}: ` : "Your membership: "}
          </span>
          <span className="text-sm font-bold dark:text-[#16191B]">{durationLabel}</span>
        </div>
        {link && (
          <span
          className="flex items-center cursor-pointer"
          onClick={handleClick}
          >
            <span className="mr-1 font-normal text-[13px] leading-5 text-[#70C3FF] underline">
              {linkLabel}
            </span>
            {!linkIsFunction && <img
              src="/assets/icons/external-link-blue.svg"
              className="inline-block w-4 h-4 object-contain"
              />
            }
          </span>
        )}
      </div>
  )
  
  if(!isVisible) {
    return null;
  }
  else if(isHeaderMode) {
    return (
    <div className="p-3 flex flex-col sticky top-0 left-0 right-0 gradient-bg-gray sm:hidden z-[1]">
      {content}
      {bottomContent}
    </div>
    )
  } else {
    return  (
    <div className="p-3 flex-col bg-[#1F2224] rounded-md mb-6 hidden sm:flex w-full dark:bg-[#eaeaea]">
      {content}
      {bottomContent}
    </div>
    )
  }
}

export default MembershipDurationLabel;